import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { FileUtil } from 'rev-shared/util/FileUtil';

import { SafeHtmlPipe } from './SafeHtml.Pipe';
import { SafeUrlPipe } from './SafeUrl.Pipe';
import { VbTitleCasePipe } from './VbTitleCase.Pipe';

@Pipe({ name: 'fileSize',
	standalone: false
})
export class FileSizeAngularPipe implements PipeTransform {
	public transform = FileUtil.formatFileSize;
}

const exports = [
	FileSizeAngularPipe,
	SafeHtmlPipe,
	SafeUrlPipe,
	VbTitleCasePipe
];

@NgModule({
	declarations: exports,
	exports
})
export class PipesAngularModule {
}
